import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { TagsRes } from 'features/tags/types/tags.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchTags = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: tags,
		isPending: isTagsLoading,
		isSuccess: isTagsSuccess
	} = useQuery<TagsRes>({
		queryKey: queryKeys.tags.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.tags(query)),
		enabled: !!auth.accessToken
	})

	return {
		tags,
		isTagsLoading,
		isTagsSuccess
	}
}
